
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// Import THDC screenshots
import thdc1 from "../../Assets/Screenshots/Thdc/WhatsApp Image 2024-06-08 at 4.49.16 PM.jpeg";
import thdc2 from "../../Assets/Screenshots/Thdc/WhatsApp Image 2024-06-08 at 4.50.30 PM (1).jpeg";
import thdc3 from "../../Assets/Screenshots/Thdc/WhatsApp Image 2024-06-08 at 4.50.30 PM.jpeg";
import thdc4 from "../../Assets/Screenshots/Thdc/WhatsApp Image 2024-06-08 at 4.50.31 PM.jpeg";
import thubthdc from "../../Assets/chatbot.png";

// Import auth screenshots
import auth1 from "../../Assets/Screenshots/Authectication/sign-up.png";
import auth2 from "../../Assets/Screenshots/Authectication/activated.png";
import auth3 from "../../Assets/Screenshots/Authectication/sign-in.png";
import thubauth from "../../Assets/auth-image.png";

// Import payment screenshots
import pay1 from "../../Assets/Screenshots/Stripe Payments/checkout-form.png";
import pay2 from "../../Assets/Screenshots/Stripe Payments/checkout-succcess.png";
import pay3 from "../../Assets/Screenshots/Stripe Payments/payment-prove.png";
import pay4 from "../../Assets/Screenshots/Stripe Payments/stripe1.png";
import pay5 from "../../Assets/Screenshots/Stripe Payments/strip2.png";
import paythumb from "../../Assets/stripe-image.png";

// Import sway screenshots
import sway1 from "../../Assets/Screenshots/Sway/sign-in page.png";
import sway2 from "../../Assets/Screenshots/Sway/dashboard.png";
import sway3 from "../../Assets/Screenshots/Sway/listdashboard.png";
import sway4 from "../../Assets/Screenshots/Sway/added-packeage-show.png";
import sway5 from "../../Assets/Screenshots/Sway/travel-package add.png";
import sway6 from "../../Assets/Screenshots/Sway/sway-code-1.png";
import sway7 from "../../Assets/Screenshots/Sway/swaylogin.png";
import sway8 from "../../Assets/Screenshots/Sway/screencapture-127-0-0-1-8000-api-docs-2024-06-09-16_33_37-2 (1).png";
import sway9 from "../../Assets/Screenshots/Sway/screencapture-127-0-0-1-8000-api-docs-2024-06-09-16_33_37-2 (3).png";
import sway10 from "../../Assets/Screenshots/Sway/screencapture-127-0-0-1-8000-api-docs-2024-06-09-16_33_37-3 (2).png";
import sway11 from "../../Assets/Screenshots/Sway/screencapture-127-0-0-1-8000-api-docs-2024-06-09-16_33_37 (1).png";
import sway12 from "../../Assets/Screenshots/Sway/screencapture-127-0-0-1-8000-api-docs-2024-06-09-16_33_37 (2).png";
import travelthumb from "../../Assets/travlimage.png";

// Import OCC screenshots
import occ1 from "../../Assets/Screenshots/StpMaanufacturing/sign-up.png";
import occ2 from "../../Assets/Screenshots/StpMaanufacturing/activated.png";
import occ3 from "../../Assets/Screenshots/StpMaanufacturing/sign-in.png";
import occ4 from "../../Assets/Screenshots/StpMaanufacturing/img1.png";
import occ5 from "../../Assets/Screenshots/StpMaanufacturing/img2.png";
import occ6 from "../../Assets/Screenshots/StpMaanufacturing/img3.png";
import occ7 from "../../Assets/Screenshots/StpMaanufacturing/img4.png";
import occ8 from "../../Assets/Screenshots/StpMaanufacturing/img5.png";
import occ9 from "../../Assets/Screenshots/StpMaanufacturing/img6.png";
import occ11 from "../../Assets/Screenshots/StpMaanufacturing/img7.png";
import occ12 from "../../Assets/Screenshots/StpMaanufacturing/img8.png";
import occ13 from "../../Assets/Screenshots/StpMaanufacturing/img9.png";
import occ14 from "../../Assets/Screenshots/StpMaanufacturing/img10.png";
import occ15 from "../../Assets/Screenshots/StpMaanufacturing/img11.png";
import occ16 from "../../Assets/Screenshots/StpMaanufacturing/img12.png";
import occ17 from "../../Assets/Screenshots/StpMaanufacturing/img13.png";
import occ18 from "../../Assets/Screenshots/StpMaanufacturing/img14.png";
import occ19 from "../../Assets/Screenshots/StpMaanufacturing/checkoutlink.png";
import occ20 from "../../Assets/Screenshots/StpMaanufacturing/checkout-form.png";
import occ21 from "../../Assets/Screenshots/StpMaanufacturing/checkout-succcess.png";
import occ22 from "../../Assets/Screenshots/StpMaanufacturing/payment-prove.png";
import occ23 from "../../Assets/Screenshots/StpMaanufacturing/stripe1.png";
import occ24 from "../../Assets/Screenshots/StpMaanufacturing/strip2.png";
import occthumb from "../../Assets/stp-image.png";
import coder from "../../Assets/coder-intro.png";

//Paint Job Website
import p1 from "../../Assets/Screenshots/PaintReady/dashboard.png"
import p2 from "../../Assets/Screenshots/PaintReady/Add-Cleint.png"
import p3 from "../../Assets/Screenshots/PaintReady/Add-new.png"
import p4 from "../../Assets/Screenshots/PaintReady/Add-technitian.png"
import p5 from "../../Assets/Screenshots/PaintReady/Jobs.png"
import p6 from "../../Assets/Screenshots/PaintReady/Daily-job-summary.png"
import p7 from "../../Assets/Screenshots/PaintReady/Services.png"
import p8 from "../../Assets/Screenshots/PaintReady/Service -items.png"
import p9 from "../../Assets/Screenshots/PaintReady/Recieved-payment.png"
import p10 from "../../Assets/Screenshots/PaintReady/redis-server.png"
import p11 from "../../Assets/Screenshots/PaintReady/sample=coode.png"
import paintthumb from "../../Assets/paint job image.png"

//Alnoor Hotel Website
import noorlading1 from "../../Assets/Screenshots/AlnoorHotel/AlnoorlandingPage.png"
import noor1 from "../../Assets/Screenshots/AlnoorHotel/AlnoorlandingPage2.png"
import noor2 from "../../Assets/Screenshots/AlnoorHotel/Alnoorlandingpage3.png"
import noor3 from "../../Assets/Screenshots/AlnoorHotel/Booking1.png"
import noor4 from "../../Assets/Screenshots/AlnoorHotel/Dashboard.png"
import noor5 from "../../Assets/Screenshots/AlnoorHotel/Booking1.png"
import noor6 from "../../Assets/Screenshots/AlnoorHotel/Alnoor1.png"
import noor7 from "../../Assets/Screenshots/AlnoorHotel/Alnoor2.png"
import noor8 from "../../Assets/Screenshots/AlnoorHotel/Alnoor3.png"

//flashCard  website
import flash from "../../Assets/Screenshots/FlashCard/Capture2.png"
//plmntaidr
import plantaidr1 from "../../Assets/Screenshots/PlantAI/code1.jpeg";
import plantaidr2 from "../../Assets/Screenshots/PlantAI/code2.jpeg";
import plantaidr3 from "../../Assets/Screenshots/PlantAI/image.jpeg";

import quran1 from "../../Assets/Screenshots/QuranLAI/ailern1.jpeg";
import quran2 from "../../Assets/Screenshots/QuranLAI/ailern2.jpeg";
import quran3 from "../../Assets/Screenshots/QuranLAI/ailern3.jpeg";
import quran4 from "../../Assets/Screenshots/QuranLAI/ailern4.jpeg";
import quran5 from "../../Assets/Screenshots/QuranLAI/ailern5.jpeg";
import quran6 from "../../Assets/Screenshots/QuranLAI/ailern6.jpeg";
import quran7 from "../../Assets/Screenshots/QuranLAI/ailern7.jpeg";

import noteiq1 from "../../Assets/Screenshots/NoteIQ/noteiq1.jpeg";
import noteiq2 from "../../Assets/Screenshots/NoteIQ/noteiq2.jpeg";
import noteiq3 from "../../Assets/Screenshots/NoteIQ/noteiq3.jpeg";
import noteiq4 from "../../Assets/Screenshots/NoteIQ/noteiq4.jpeg";
import noteiq5 from "../../Assets/Screenshots/NoteIQ/noteiq5.jpeg";
import noteiq6 from "../../Assets/Screenshots/NoteIQ/noteiq6.jpeg";
import noteiq7 from "../../Assets/Screenshots/NoteIQ/noteiq7.jpeg";
import noteiq8 from "../../Assets/Screenshots/NoteIQ/noteiq8.jpeg";
import noteiq9 from "../../Assets/Screenshots/NoteIQ/noteiq9.jpeg";
import noteiq10 from "../../Assets/Screenshots/NoteIQ/noteiq10.jpeg";
import noteiq11 from "../../Assets/Screenshots/NoteIQ/noteiq11.jpeg";

import hairsr from "../../Assets/Screenshots/HairSR/hairrecthumbnail.png";
import faceshimage from "../../Assets/Screenshots/FaceReco/face.png";

// ChainGPT SECs screenshots
import chainGpt1 from "../../Assets/Screenshots/chaingptsecs/Gemini_Generated_Image_tz5pmdtz5pmdtz5p (1).png";
import chainGpt2 from "../../Assets/Screenshots/chaingptsecs/Gemini_Generated_Image_go8iwqgo8iwqgo8i(1) (1).png";
import chainGpt3 from "../../Assets/Screenshots/chaingptsecs/Gemini_Generated_Image_78b4he78b4he78b4 (2).png";
import chainGpt4 from "../../Assets/Screenshots/chaingptsecs/Gemini_Generated_Image_78b4he78b4he78b4 (1).png";
import chainGpt5 from "../../Assets/Screenshots/chaingptsecs/Gemini_Generated_Image_4apiad4apiad4api (1).png";

// FamOfficeChatbot screenshots
import famOffice1 from "../../Assets/Screenshots/FamOfficeChatbot/fo1.png";
import famOffice2 from "../../Assets/Screenshots/FamOfficeChatbot/fo2.png";
import famOffice3 from "../../Assets/Screenshots/FamOfficeChatbot/fo3.png";

// MultiDocChatbot screenshots
import multiDoc1 from "../../Assets/Screenshots/MultiDocChatbot/Screenshot From 2026-04-04 17-59-58.png";
import multiDoc2 from "../../Assets/Screenshots/MultiDocChatbot/Screenshot From 2026-04-04 18-03-01.png";
import multiDoc3 from "../../Assets/Screenshots/MultiDocChatbot/Screenshot From 2026-04-04 18-03-16.png";
import multiDoc4 from "../../Assets/Screenshots/MultiDocChatbot/Screenshot From 2026-04-04 18-03-53.png";
import multiDoc5 from "../../Assets/Screenshots/MultiDocChatbot/Screenshot From 2026-04-04 18-04-19.png";

// Retell Twilio Agent screenshots
import retell1 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-35-18.png";
import retell2 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-35-12.png";
import retell3 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-34-59.png";
import retell4 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-34-25.png";
import retell5 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-34-19.png";
import retell6 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-34-11.png";
import retell7 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-27-40.png";
import retell8 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-27-18.png";
import retell9 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-26-20.png";
import retell10 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-26-04.png";
import retell11 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-25-52.png";
import retell12 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-25-44.png";
import retell13 from "../../Assets/Screenshots/retelltwilioagent/Screenshot From 2026-04-11 14-25-36.png";

function Projects() {
  const paymentshots = [auth1, auth2, auth3, pay1, pay2, pay3, pay4, pay5];
  const authshots = [auth1, auth2, auth3];
  const thdcScreenshots = [thdc1, thdc2, thdc3, thdc4];
  const swayshots = [
    sway1, sway2, sway3, sway4, sway5,
    sway6, sway7, sway8, sway9, sway10,
    sway11, sway12
  ];
  const occshots = [
    occ1, occ2, occ3, occ4, occ5, occ6, occ7, occ8, occ9, occ11, occ12,
    occ13, occ14, occ15, occ16, occ17, occ18, occ19, occ20, occ21, occ22, occ23, occ24
  ];
  const allnoorshots = [
    noorlading1, noor1, noor2, noor3, noor4, noor5, noor6, noor7, noor1, noor8
  ];
  const paintshots = [
    p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11
  ];
  const flashshots = [flash];
  const plantaidrshots = [plantaidr1, plantaidr2, plantaidr3];
  const aiquranshots = [quran1, quran2, quran3, quran4, quran5, quran6, quran7];
  const noteiqshots = [noteiq1, noteiq2, noteiq3, noteiq4, noteiq5, noteiq6, noteiq7, noteiq8, noteiq9, noteiq10, noteiq11];
  const hairsrshots = [hairsr];
  const faceshots = [faceshimage];
  const chainGptShots = [chainGpt1, chainGpt2, chainGpt3, chainGpt4, chainGpt5];
  const famOfficeShots = [famOffice1, famOffice2, famOffice3];
  const multiDocShots = [multiDoc1, multiDoc2, multiDoc3, multiDoc4, multiDoc5];
  const retellShots = [retell1, retell2, retell3, retell4, retell5, retell6, retell7, retell8, retell9, retell10, retell11, retell12, retell13];

  return (
    <Container fluid className="project-section" id="projects">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Latest <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          {/* ChainGPT */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chainGpt2}
              isBlog={false}
              title="ChainGPT.org AI Trading Assistant"
              description="Led the backend architecture and system design for an enterprise grade AI financial intelligence platform. Built scalable RAG pipelines to process and structure 10,000+ regulatory and financial documents including 10-K, 10-Q, and earnings reports."
              ghLink={null}
              occshots={chainGptShots}
              techStack={["Python", "FastAPI", "LangChain", "Pinecone", "LLM", "RAG"]}
            />
          </Col>

          {/* FamOffice Chatbot */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={famOffice2}
              isBlog={false}
              title="Family Office AI Assistant"
              description="Led the technical architecture and backend implementation of a secure AI assistant designed for ultra high net worth family office operations. Built a privacy first RAG system over sensitive financial and investment documents."
              ghLink={null}
              occshots={famOfficeShots}
              techStack={["Python", "FastAPI", "LangChain", "LLM", "Encryption", "RAG"]}
            />
          </Col>

          {/* MultiDocChatbot */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={multiDoc4}
              isBlog={false}
              title="Enterprise Multi-Document RAG"
              description="Led the architecture and development of a large scale enterprise knowledge retrieval system designed to unify and search across massive internal document repositories."
              ghLink={null}
              occshots={multiDocShots}
              techStack={["FastAPI", "LangChain", "Pinecone", "Python", "RAG", "LLM"]}
            />
          </Col>

          {/* NoteIQ */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={noteiq11}
              isBlog={false}
              title="Enterprise Meeting Intelligence"
              description="Full-stack engineering lead for AI meeting intelligence platform serving enterprise clients. Built real-time and post-meeting transcription with speaker diarization, NLP extraction, and actionable summarization."
              ghLink={null}
              occshots={noteiqshots}
              techStack={["Python", "NLP", "ASR", "LLM", "Slack API", "Salesforce"]}
            />
          </Col>

          {/* Retell Twilio Voice Agent */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={retell1}
              isBlog={false}
              title="Enterprise AI Voice Agent"
              description="Led the architecture and backend engineering of a large scale AI voice automation system handling high volume inbound and outbound calls in production environments."
              ghLink={null}
              occshots={retellShots}
              techStack={["Retell", "Twilio", "Python", "FastAPI", "CRM Integration", "LLM"]}
            />
          </Col>

          {/* AI Quran */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={quran5}
              isBlog={false}
              title="AI Quran Learning Platform"
              description="Lead architect for speech-enabled Islamic education platform using ASR and NLP. Built real-time pronunciation analysis with Tajweed rule enforcement."
              aiquran={aiquranshots}
              ghLink={null}
              techStack={["Python", "ASR", "NLP", "LLM", "Tajweed", "Speech Recognition"]}
            />
          </Col>

          {/* THDC Dental Care */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={thubthdc}
              isBlog={false}
              title="Dental Care AI Assistant"
              description="Led the design and backend development of an AI powered healthcare assistant focused on dental care support and patient interaction automation."
              ghLink="https://github.com/Shahid-Sheimi/Thdc.git"
              thdcScreenshots={thdcScreenshots}
              techStack={["Python", "LLM", "RAG", "FastAPI", "HIPAA", "Medical AI"]}
            />
          </Col>

          {/* Plant Disease Detection */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={plantaidr2}
              isBlog={false}
              title="AI Plant Disease Detection"
              description="Lead engineer for computer vision plant health system deployed in agricultural cooperatives. Built CNN-based disease classification with GPT integration for actionable insights."
              ghLink={null}
              occshots={plantaidrshots}
              techStack={["Python", "CNN", "TensorFlow", "GPT", "Computer Vision", "Agriculture AI"]}
            />
          </Col>

          {/* Hair Product Advisor */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hairsr}
              isBlog={false}
              title="AI Hair Product Advisor"
              description="Technical lead for AI beauty recommendation system with QR product scanning and user profiling."
              ghLink={null}
              occshots={hairsrshots}
              techStack={["Python", "ML", "Dermatology DB", "QR Scan", "Recommendation System"]}
            />
          </Col>

          {/* Face Recognition */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={faceshimage}
              isBlog={false}
              title="Face Recognition & Emotion AI"
              description="Lead engineer for enterprise face recognition and emotion detection system using deep learning."
              ghLink={null}
              occshots={faceshots}
              techStack={["Python", "Deep Learning", "OpenAI", "Computer Vision", "GDPR", "Security"]}
            />
          </Col>

          {/* JWT Auth */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={thubauth}
              isBlog={false}
              title="Django JWT Authentication"
              description="Lead architect for enterprise authentication system with Django REST Framework and JWT."
              ghLink="https://github.com/Shahid-Sheimi/JWT-Authentication-in-Django-with-Python"
              authshots={authshots}
              techStack={["Django", "Python", "JWT", "REST API", "OAuth2", "RBAC"]}
            />
          </Col>

          {/* Travel Booking */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={travelthumb}
              isBlog={false}
              title="Travel Booking API Platform"
              description="Lead engineer for enterprise travel API platform integrating flights, hotels, and car rentals."
              ghLink="https://github.com/Shahid-Sheimi?tab=repositories"
              swayshots={swayshots}
              techStack={["Python", "Django", "REST API", "OTP", "Stripe", "Token Auth"]}
            />
          </Col>

          {/* Paint Job */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={paintthumb}
              isBlog={false}
              title="The Paint Job Website"
              description="Paint Job Website is a robust software solution tailored for painting businesses, enabling seamless management of clients, technicians, properties, jobs, services, and payments."
              ghLink="https://github.com/Shahid-Sheimi/Travel-Website.git"
              paintshots={paintshots}
              techStack={["Python", "Django", "Redis", "PostgreSQL", "Bootstrap", "Payment"]}
            />
          </Col>

          {/* Alnoor Hotel */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={noorlading1}
              isBlog={false}
              title="All Noor Hotel Website"
              description="All Noor Hotel Skardu is a premier accommodation option nestled in the breathtaking landscapes of Skardu."
              ghLink="https://github.com/Shahid-Sheimi/all_noor_hotel"
              allnoorshots={allnoorshots}
              techStack={["HTML", "CSS", "JavaScript", "Booking System", "Responsive Design"]}
            />
          </Col>

          {/* OCC Manufacturing */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={occthumb}
              isBlog={false}
              title="OpenCascade Manufacturing Website API"
              description="The OCC Manufacturing Backend is a platform designed to manufacturing process with enhanced security measures and user-friendly features."
              ghLink="https://github.com/Shahid-Sheimi/OCC-Manufacturing.git"
              occshots={occshots}
              techStack={["Python", "Django", "STP Files", "API", "Stripe", "Manufacturing"]}
            />
          </Col>

          {/* Flash Card */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={coder}
              isBlog={false}
              title="Flash Card Website"
              description="Flash Card Website for learning and memorization with interactive UI."
              ghLink="https://github.com/Shahid-Sheimi?tab=repositories"
              flashshots={flashshots}
              techStack={["React", "JavaScript", "CSS", "Education", "Interactive UI"]}
            />
          </Col>

          {/* Stripe Payments */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={paythumb}
              isBlog={false}
              title="Stripe Payments Integration"
              description="The Python Django JWT Authentication and Stripe Payments System is a comprehensive solution for secure user authentication and seamless payment processing."
              ghLink="https://github.com/Shahid-Sheimi/stripe-payment-.git"
              paymentshots={paymentshots}
              techStack={["Django", "Python", "Stripe", "JWT", "Email", "Payments"]}
            />
          </Col>

        </Row>
      </Container>

      {/* CTA Section */}
      <Container className="mt-5">
        <div className="project-cta">
          <h3>Like what you see?</h3>
          <p>Let's discuss how I can help bring your project to life.</p>
          <a href="#contacts" className="cta-button">
            Let's Talk →
          </a>
        </div>
      </Container>

      <style>{`
        .project-cta {
          text-align: center;
          padding: 50px 30px;
          background: linear-gradient(135deg, rgba(0,198,255,0.1), rgba(0,114,255,0.1));
          border-radius: 24px;
          border: 1px solid rgba(0,198,255,0.2);
          margin-top: 60px;
        }
        .project-cta h3 {
          color: white;
          font-family: 'Syne', sans-serif;
          font-size: 2rem;
          margin-bottom: 12px;
        }
        .project-cta p {
          color: rgba(200,210,255,0.7);
          font-size: 1.1rem;
          margin-bottom: 24px;
        }
        .cta-button {
          display: inline-block;
          padding: 14px 36px;
          background: linear-gradient(90deg, #00c6ff, #0072ff);
          color: white;
          text-decoration: none;
          border-radius: 50px;
          font-weight: 600;
          font-size: 1rem;
          transition: all 0.3s ease;
          box-shadow: 0 8px 24px rgba(0,114,255,0.35);
        }
        .cta-button:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 32px rgba(0,114,255,0.5);
          color: white;
          text-decoration: none;
        }
      `}</style>
    </Container>
  );
}

export default Projects;

